import { Dialog } from "primereact/dialog";
import React from "react";
import { authAPI } from "../../api/auth";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { lp } from "../../utils/logPrefix";
import { pluginComponentStore } from "../../utils/PluginComponents";
import { CvpButton } from "../buttons/CvpButton";

export function showRequestStorageAccessDialog(): Promise<boolean> {
  return new Promise((resolve) => {
    const dialog = () => {
      const L = useLocStore(LocContext.GENERAL);

      return (
        <Dialog
          visible
          onHide={() => {}}
          closable={false}
          header={L.id("6054de0618b6").loc("Webtemp trenger tilgang")}
        >
          <CvpButton
            label={L.id("2f300304db7a").loc(
              "Gi appen tilgang for å fullføre innlogging"
            )}
            icon="pi pi-login"
            onClick={async () => {
              try {
                await document.requestStorageAccess();
                const whoAmI = await authAPI.whoAmI({});

                const hasCookies = !!whoAmI.id;

                resolve(hasCookies);

                if (!hasCookies) {
                  console.error(lp(), "Failed to request storage access #1");
                }
              } catch (err) {
                resolve(false);
                console.error(lp(), "Failed to request storage access #2", err);
              }

              pluginComponentStore.remove(key);
            }}
          />
        </Dialog>
      );
    };

    const key = pluginComponentStore.add(dialog);
  });
}
